<template>
   <div id="playlist-container"
      :style="playlistStle"
      >
      <div class="playlist-info" 
         v-for="video in playlistArr"
         :class="{active : selectURL == video.url.mp4}">
         <div class="video-menu row">
            <div 
               class="video-thumbnail-container col-md-5 col-5"
               v-bind:style="{backgroundImage : 'url('+ video.thumbnail +')'}">
               <div 
                  class="player-indicator"
                  v-show="selectURL == video.url">
                  
               </div>
               <div
                  v-show="selectURL != video.url.mp4"> 
                  <center>
                     
                  </center>                  
               </div>
            </div>
            <div class="video-info col-md-7 col-7">
               <a href="#" @click.prevent="selectVideo(video)"><h5>{{ video.title }}</h5></a>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   props : {
      playlistArr : Array,
      selected : String,
      selectURL : String,
      defaultHeight : Number
   },
   data() {
      return {
         playlistStle : {
            maxHeight : this.defaultHeight + 'px'
         }
      }
   },
   methods : {
      selectVideo(value) {
         this.$emit('selectNewVideo',value.url)
         this.$emit('selectNewThumbnail',value.thumbnail)
      }
   }
}
</script>

<style scoped>
   .row{
      margin:0;
   }
   .video-menu.row{
      width: 100%;
      display: flex;
      justify-content: space-between;
   }
   .video-menu.row .video-thumbnail-container{
      width: 35%;
   }
   .video-menu.row .video-info{
      width: 62%;
   }
   .playlist-info{
      background-color:#324767;
      font-family:Arial, Helvetica, sans-serif;
   }
   .playlist-info.active {
      background-color:#0f161f;
   }
   #playlist-container{
      padding:0;
      height:360px;
      overflow: scroll;
      overflow-x: hidden;
   }
   .playlist-info{
      display: flex;
      margin-bottom: 5px;
      height: 68px;
   }
   .video-thumbnail-container{
      color:#fff;
      background-color:#192538;
      display: flex;
      justify-content: center;
      align-items: center;
      background-size: cover;
   }
   .video-info a{
      text-decoration: none;
   }
   .video-info h5{
      color: #fff;
      font-weight: 400;
      font-size:12px;
      padding: 15px 15px 15px 5px;
      margin: 0px;
   }
</style>



// WEBPACK FOOTER //
// src/components/Playlist.vue